import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePlatform } from '../providers/PlatformProvider';

export function usePlatformBack(): void {
  const platform = usePlatform();
  const navigate = useNavigate();

  useEffect(() => {
    platform.showBackButton(() => navigate(-1));
    return () => {
      platform.hideBackButton();
    };
  }, [platform, navigate]);
}
